export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-07.9e97277c.jpg";